/* KIRIBAN hero film: a dimmed background that loops forever. Muted autoplay, sound toggle, pauses when scrolled away.
   With reduced motion the film stays on its poster frame. */
(function () {
  "use strict";
  var root = document.querySelector("[data-kb-film]");
  if (!root) return;
  var v = root.querySelector("video"), amb = root.querySelector(".kbf-amb"), stage = root.querySelector(".kbf-stage");
  var snd = root.querySelector("[data-kbf-snd]");
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var conn = navigator.connection || {};
  // phones and screens that show the film under ~1100 device pixels tall get the 720p file; others 1080p
  var need = (root.getBoundingClientRect().height || innerHeight) * (window.devicePixelRatio || 1);
  var small = conn.saveData || /(^|-)2g$/.test(conn.effectiveType || "") ||
              matchMedia("(pointer: coarse)").matches || need < 1100;
  var visible = true;

  v.src = (small ? root.getAttribute("data-sd") : root.getAttribute("data-hd")) || root.getAttribute("data-hd");
  v.muted = true; v.defaultMuted = true; v.setAttribute("muted", ""); v.loop = true;

  function play() { if (reduce && v.muted) return; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  play();

  snd.addEventListener("click", function () {
    var on = v.muted;                     // turning sound ON
    v.muted = !on;
    snd.setAttribute("aria-pressed", on ? "true" : "false");
    snd.setAttribute("aria-label", snd.getAttribute(on ? "data-off" : "data-on") || "");
    if (on && v.paused) v.play().catch(function () {});
  });

  // pause when the hero leaves the screen, resume when it comes back
  if ("IntersectionObserver" in window) {
    new IntersectionObserver(function (es) {
      visible = es[0].isIntersecting;
      if (!visible && !v.paused) v.pause();
      else if (visible && v.paused) play();
    }, { threshold: 0.15 }).observe(root);
  }
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible" && visible && v.paused) play();
  });

  // blurred glow of the film beside the stage (wide screens only)
  var ctx = null;
  try { ctx = amb.getContext("2d"); } catch (e) {}
  function wide() { return stage.getBoundingClientRect().width < root.getBoundingClientRect().width - 40; }
  if (ctx && !reduce) {
    var last = 0;
    (function draw(now) {
      if (visible && wide() && now - last > 150 && v.readyState >= 2) {
        last = now;
        try { ctx.drawImage(v, 0, 0, 18, 32); root.classList.add("has-amb"); }
        catch (e) { ctx = null; root.classList.remove("has-amb"); return; }
      }
      requestAnimationFrame(draw);
    })(0);
  }
})();
